var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "nft_container"
  }, [_vm.payloads ? [_vm.payloads.length > 0 ? _c('NFTLogoPayload', {
    attrs: {
      "payload": _vm.payloads[0][0],
      "asset-i-d": _vm.asset.id,
      "group-i-d": _vm.payloads[0][1]
    }
  }) : _c('LogoFallback')] : _c('LogoFallback')], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }